// Cases des observations par étage. Les rapports déjà enregistrés gardent
// leur texte : ces listes ne servent qu'à la saisie.

export const FULL_FLOOR_OPTIONS = [
  'RAS',
  'Portes non verrouillées',
  'Lumières allumées',
  'Projecteurs allumés',
  'PCs allumés',
  'Poubelles non vidées',
  'Fenêtres ouvertes',
  'Stores ouverts',
];

const RAS_ONLY = ['RAS'];

// Buanderie et vestiaires n'ont ni projecteur, ni PC, ni store.
const WITHOUT_PROJECTOR_PC_OR_BLINDS = FULL_FLOOR_OPTIONS.filter(
  (item) => !['Projecteurs allumés', 'PCs allumés', 'Stores ouverts'].includes(item),
);

export const FLOOR_OBSERVATION_OPTIONS = {
  'Sous-sol': RAS_ONLY,
  'Rez-de-chaussée': RAS_ONLY,
  '1er': FULL_FLOOR_OPTIONS,
  // La buanderie du 1er étage. Le libellé de l'application est au pluriel.
  'Buanderie étudiants': WITHOUT_PROJECTOR_PC_OR_BLINDS,
  // Pas de projecteur. La porte extérieure se relève seulement si elle n'est pas verrouillée.
  'Administration 120': [
    'RAS',
    'Portes non verrouillées',
    'Lumières allumées',
    'PCs allumés',
    'Poubelles non vidées',
    'Fenêtres ouvertes',
    'Stores ouverts',
    'Porte extérieur non verrouillée',
  ],
  '2ème': [
    'RAS',
    'Lumière local pause allumée',
    'Porte local pause ouverte',
    'Porte local pause non-verrouillée',
    'Fenêtre local pause ouverte',
  ],
  // Vestiaires femme et homme sont une seule ligne : « Vestiaires f/h ».
  'Vestiaires f/h': WITHOUT_PROJECTOR_PC_OR_BLINDS,
  '3ème': RAS_ONLY,
  '4ème': RAS_ONLY,
  '5ème': RAS_ONLY,
};
